// ==========================================
// GENDER
// ==========================================

export const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
    { value: "Prefer not to say", label: "Prefer not to say" }
];

// ==========================================
// EDUCATION LEVEL
// ==========================================

export const educationOptions = [
    { value: "High School", label: "High School" },
    { value: "Diploma", label: "Diploma" },
    { value: "Bachelor's Degree", label: "Bachelor's Degree" },
    { value: "Master's Degree", label: "Master's Degree" },
    { value: "PhD", label: "PhD" },
    { value: "Other", label: "Other" }
];

// ==========================================
// INTERNSHIP DOMAIN
// ==========================================

export const domainOptions = [
    { value: "Web Development", label: "Web Development" },
    { value: "Frontend Development", label: "Frontend Development" },
    { value: "Backend Development", label: "Backend Development" },
    { value: "Full Stack Development", label: "Full Stack Development" },
    { value: "Android Development", label: "Android Development" },
    { value: "Flutter Development", label: "Flutter Development" },
    { value: "Java Development", label: "Java Development" },
    { value: "Python Development", label: "Python Development" },
    { value: "Machine Learning", label: "Machine Learning" },
    { value: "Artificial Intelligence", label: "Artificial Intelligence" },
    { value: "Data Science", label: "Data Science" },
    { value: "Data Analytics", label: "Data Analytics" },
    { value: "UI/UX Design", label: "UI/UX Design" },
    { value: "Graphic Design", label: "Graphic Design" },
    { value: "Digital Marketing", label: "Digital Marketing" },
    { value: "SEO", label: "SEO" },
    { value: "Content Writing", label: "Content Writing" },
    { value: "Business Development", label: "Business Development" },
    { value: "Cloud Computing", label: "Cloud Computing" },
    { value: "Cyber Security", label: "Cyber Security" }
];

// ==========================================
// INTERNSHIP DURATION
// ==========================================

export const durationOptions = [
    { value: "1 Month", label: "1 Month" },
    { value: "2 Months", label: "2 Months" },
    { value: "3 Months", label: "3 Months" },
    { value: "6 Months", label: "6 Months" },
    { value: "Flexible", label: "Flexible" }
];

// ==========================================
// CONTACT METHOD
// ==========================================

export const contactMethodOptions = [
    { value: "Email", label: "Email" },
    { value: "Phone Call", label: "Phone Call" },
    { value: "WhatsApp", label: "WhatsApp" }
];

// ==========================================
// HEAR ABOUT US
// ==========================================

export const hearAboutOptions = [
    { value: "Google Search", label: "Google Search" },
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Instagram", label: "Instagram" },
    { value: "Facebook", label: "Facebook" },
    { value: "YouTube", label: "YouTube" },
    { value: "Friend / Referral", label: "Friend / Referral" },
    { value: "College", label: "College" },
    { value: "WhatsApp", label: "WhatsApp" },
    { value: "Other", label: "Other" }
];

// ==========================================
// INDIAN STATES & UTs
// ==========================================

export const stateOptions = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar", label: "Bihar" },
    { value: "Chhattisgarh", label: "Chhattisgarh" },
    { value: "Goa", label: "Goa" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jharkhand", label: "Jharkhand" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Manipur", label: "Manipur" },
    { value: "Meghalaya", label: "Meghalaya" },
    { value: "Mizoram", label: "Mizoram" },
    { value: "Nagaland", label: "Nagaland" },
    { value: "Odisha", label: "Odisha" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Sikkim", label: "Sikkim" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "Telangana", label: "Telangana" },
    { value: "Tripura", label: "Tripura" },
    { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    { value: "Uttarakhand", label: "Uttarakhand" },
    { value: "West Bengal", label: "West Bengal" },
    { value: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
    { value: "Chandigarh", label: "Chandigarh" },
    { value: "Dadra and Nagar Haveli and Daman and Diu", label: "Dadra and Nagar Haveli and Daman and Diu" },
    { value: "Delhi", label: "Delhi" },
    { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
    { value: "Ladakh", label: "Ladakh" },
    { value: "Lakshadweep", label: "Lakshadweep" },
    { value: "Puducherry", label: "Puducherry" }
];